import { createGlobalStyle } from "styled-components";
import { reset } from "react95";

const GlobalStyle = createGlobalStyle`
  ${reset}
`;

export default GlobalStyle;
